// extracted by mini-css-extract-plugin
export var popperCloseAnimation = "MobileHeaderMenuButton-module--popperCloseAnimation--11f76";
export var popperOpenAnimation = "MobileHeaderMenuButton-module--popperOpenAnimation--099a7";
export var scaleDown = "MobileHeaderMenuButton-module--scaleDown--23620";
export var scaleUp = "MobileHeaderMenuButton-module--scaleUp--4a97a";
export var style_closeButton = "MobileHeaderMenuButton-module--style_closeButton--67cfb";
export var style_logInButton = "MobileHeaderMenuButton-module--style_logInButton--7031a";
export var style_menuButton = "MobileHeaderMenuButton-module--style_menuButton--e5424";
export var theme = "\"@theme.css\"";